/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum TechnicalVisitFormAliases {
  ACTION_FINISH = 'action-finish',
  ACTION_START = 'action-start',
  AUTOCOMPLETE_MENU_MOBILE = 'autocomplete-menu-mobile',
  BREADCRUMB_0 = 'breadcrumb-0',
  CARD_FILES = 'card-files',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  CONTEXTUAL_BAR_1 = 'contextual-bar-1',
  DECK = 'deck',
  DECK_MENU = 'deck-menu',
  FETCH_ATTACHMENTS = 'fetch-attachments',
  FETCH_QUESTIONNAIRE = 'fetch-questionnaire',
  FETCH_TECHNICAL_VISIT_FORMS_MENU = 'fetch-technical-visit-forms-menu',
  FETCH_TECHNICAL_VISIT_FORMS_MENU_MOBILE = 'fetch-technical-visit-forms-menu-mobile',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_3 = 'field-3',
  FIELD_4 = 'field-4',
  FIELD_5 = 'field-5',
  FIELD_FILE_UPLOADER = 'field-file-uploader',
  FIELD_IMAGE = 'field-image',
  FIELD_MENU = 'field-menu',
  FIELD_NOTE = 'field-note',
  FILE_UPLOADER_0 = 'file-uploader-0',
  FORM_MENU_MOBILE = 'form-menu-mobile',
  FORM_SEND_ATTACHMENTS = 'form-send-attachments',
  HPMS_CUSTOM_CARD = 'hpms-custom-card',
  HPMS_CUSTOM_CARD_0 = 'hpms-custom-card-0',
  HPMS_FORM_TECHNICAL_VISIT = 'hpms-form-technical-visit',
  IMAGE_0 = 'image-0',
  LAYOUT_0 = 'layout-0',
  LAYOUT_2 = 'layout-2',
  LAYOUT_ADDITIONAL_INFORMATION = 'layout-additional-information',
  LAYOUT_GENERAL_FORMS = 'layout-general-forms',
  LAYOUT_UPLOAD = 'layout-upload',
  LOADER_0 = 'loader-0',
  MAPPER_0 = 'mapper-0',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_2 = 'panel-2',
  PANEL_3 = 'panel-3',
  PANEL_5 = 'panel-5',
  PANEL_ADDITIONAL_INFORMATION = 'panel-additional-information',
  PANEL_ATTACHMENTS = 'panel-attachments',
  PANEL_FORM_SEND_ATTACHMENT = 'panel-form-send-attachment',
  PANEL_GENERAL_FORMS = 'panel-general-forms',
  PANEL_MAIN = 'panel-main',
  PANEL_MENU = 'panel-menu',
  PANEL_MOBILE = 'panel-mobile',
  PANEL_TITLE = 'panel-title',
  PANEL_TITLE_ATTACHMENT = 'panel-title-attachment',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_AREA_1 = 'text-area-1',
  TEXT_DATE = 'text-date',
  TEXT_MAPPER = 'text-mapper',
  TEXT_QUIESTIONNAIRE_TITLE = 'text-quiestionnaire-title',
  TEXT_TITLE = 'text-title',
}
export { TechnicalVisitFormAliases };
